import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import dayjs from 'dayjs';
import { filter } from 'rxjs/operators';
import { LogFilters, LogResult, UserActivity } from '../../../shared/types/UserActivity';
import API_END_POINTS from '../../constants/apiEndPoints';

@Injectable({
  providedIn: 'root',
})
export class UserActivityService {
  private currentPage: UserActivity | undefined = undefined;
  private expiryTimeInSec: number = 900;
  private userEnteredOnPageTime?: Date = undefined;
  private interval: NodeJS.Timeout | null = null;
  private http = inject(HttpClient);
  private router = inject(Router);

  trackPageViews() {
    this.onLeaveTabLogHandler();
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((value) => {
        const event: NavigationEnd = value as NavigationEnd;
        const currentTime = dayjs().toDate();
        this.userEnteredOnPageTime = currentTime;
        if (this.currentPage) {
          this.currentPage.outTimestamp = currentTime;
          this.currentPage.spentTime = dayjs(currentTime).diff(this.currentPage.inTimestamp, 'seconds')
          this.logActivity('page-visit', event.urlAfterRedirects);
        } else {
          this.userEnteredOnPageTime = currentTime;
          this.currentPage = {
            pageName: event.urlAfterRedirects,
            inTimestamp: currentTime,
            action: 'page-visit'
          }
        }
        this.initiateTimer();
      });
  }

  private onLeaveTabLogHandler = (): void => {
    window.addEventListener('beforeunload', () => {
      const currentTime = dayjs().toDate();
      if (this.currentPage) {
        this.currentPage.outTimestamp = currentTime;
        this.currentPage.spentTime = dayjs(currentTime).diff(this.currentPage.inTimestamp, 'seconds')
      }
      this.logActivity('tab-close');
      this.clearPageInterval();
    })

  }

  private logActivity(action: UserActivity['action'], url?: string) {
    if (this.currentPage) {
      this.currentPage.action = action;
      this.sendLogToServer(this.currentPage);
      if (url) {
        this.currentPage = {} as UserActivity
        this.currentPage.pageName = url;
        this.currentPage.inTimestamp = dayjs().toDate();
      }
    }


  }

  clearPageInterval = () => {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  private initiateTimer = () => {
    this.clearPageInterval();
    this.interval = setInterval(() => {

      if (this.userEnteredOnPageTime && dayjs().diff(this.userEnteredOnPageTime, 'seconds') > this.expiryTimeInSec) {
        const currentTime = dayjs().toDate();
        if (this.currentPage) {
          this.currentPage.outTimestamp = currentTime;
          this.currentPage.spentTime = dayjs(currentTime).diff(this.currentPage.inTimestamp, 'seconds')
          this.logActivity('user-idle',);
          if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
          }
        }
      }
    }, 2000);
  }
  
  private sendLogToServer(log: UserActivity) {
    this.http.post(API_END_POINTS.LOG_ACTIVITY, log).subscribe();
  }

  fetchLogs(logFilters: LogFilters) {
    return this.http.post<{data: {logs: LogResult[], totalCount: number}}>(API_END_POINTS.FETCH_LOGS, logFilters);
  }

}